import React, { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { ThemeProvider } from '@material-ui/core/styles';

import BaseErrorState from '@/components/BaseErrorState';
import { isSpark as isSparkHelper } from '@/utils/productHelpers';
import sparkTheme from '@/themes/sparkTheme';

interface ErrorStateProps {
  onNext: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onNext }) => {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const { getValues, resetField } = useFormContext();
  const { product } = useParams<{ product?: string }>();
  const isSpark = isSparkHelper(product);

  useEffect(() => {
    posthog.capture('ActivationFlowErrored', { email: getValues('email') });
  }, [posthog, getValues]);

  const handleTryAgain = () => {
    resetField('termsAndPrivacy');
    onNext();
  };

  const supportEmailKey = isSpark
    ? 'coverage.spark.patient.info_popup.email_spark'
    : 'coverage.pre_onboarding.sleepio.error_state.support_email';

  const content = (
    <BaseErrorState
      title={t('coverage.pre_onboarding.sleepio.error_state.title')}
      supportText={t('coverage.pre_onboarding.sleepio.error_state.support_text')}
      supportEmail={t(supportEmailKey)}
      buttonText={t('coverage.pre_onboarding.sleepio.error_state.button_text')}
      onButtonClick={handleTryAgain}
      maxWidth={false}
    />
  );

  return isSpark ? (
    <ThemeProvider theme={sparkTheme}>{content}</ThemeProvider>
  ) : (
    content
  );
};
